(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pop-reviews-demo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pop-reviews-demo')) {
  customElements.define('pop-reviews-demo', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.pop-reviews-demo__track');
      this.cards = [...this.track.children];
      this.dots = this.querySelector('.pop-reviews-demo__dots');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.prev.onclick = () => this.go(this.page - 1);
      this.next.onclick = () => this.go(this.page + 1);
      this.onScroll = () => this.sync();
      this.track.addEventListener('scroll', this.onScroll, {passive:true});
      this.observer = new ResizeObserver(() => this.build());
      this.observer.observe(this.track);
      this.build();
    }
    disconnectedCallback() {this.observer?.disconnect();this.track?.removeEventListener('scroll', this.onScroll);}
    build() {
      const stride = this.cards[0].getBoundingClientRect().width + 20;
      this.size = Math.max(1, Math.round(this.track.clientWidth / stride));
      this.pages = Math.ceil(this.cards.length / this.size);
      this.dots.replaceChildren();
      for (let i=0;i<this.pages;i++) {
        const button = document.createElement('button');button.type='button';button.className='pop-reviews-demo__dot';
        button.setAttribute('aria-label',this.querySelector('[data-page-label]').content.textContent.replace('[number]',i+1));
        button.onclick=()=>this.go(i);this.dots.append(button);
      }
      this.sync();
    }
    go(page) {
      page=Math.max(0,Math.min(page,this.pages-1));
      const left=this.cards[Math.min(page*this.size,this.cards.length-1)].offsetLeft-this.cards[0].offsetLeft;
      this.track.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    }
    sync() {
      const stride=this.cards[0].getBoundingClientRect().width+20;
      const atEnd=this.track.scrollLeft>=this.track.scrollWidth-this.track.clientWidth-2;
      this.page=atEnd?this.pages-1:Math.min(this.pages-1,Math.round(this.track.scrollLeft/(stride*this.size)));
      this.prev.disabled=this.page===0;this.next.disabled=this.page===this.pages-1;
      [...this.dots.children].forEach((b,i)=>b.setAttribute('aria-current',i===this.page?'true':'false'));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wapc-launch-offer"] && !Shopify.designMode) return;
  try {
    
  function initWapcLaunch() {
    document.querySelectorAll('[data-wapc-launch]').forEach(function (banner) {
      if (banner.dataset.initialized) return;
      banner.dataset.initialized = 'true';
      const end = Date.parse(banner.dataset.end);
      let interval;
      function update() {
        const remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (!Number.isFinite(end) || remaining <= 0) {
          banner.hidden = true;
          clearInterval(interval);
          return;
        }
        banner.querySelector('[data-hours]').textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
        banner.querySelector('[data-minutes]').textContent = String(Math.floor(remaining / 60) % 60).padStart(2, '0');
        banner.querySelector('[data-seconds]').textContent = String(remaining % 60).padStart(2, '0');
      }
      update();
      if (!banner.hidden) interval = setInterval(update, 1000);
    });
  }
  initWapcLaunch();
  document.addEventListener('shopify:section:load', initWapcLaunch);

  } catch(e) { console.error(e); }
})();
})();
